import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import i18n from 'modules/core/lib/i18n'

import { useEmployeePictures } from 'modules/employees/components/blocks/FaceRecognition/EmployeePicturesContext'

import Item from './Item'

interface Props {
  canRemovePicture: boolean
  canDownloadPicture: boolean
}

const EmployeePictures = ({ canRemovePicture, canDownloadPicture }: Props) => {
  const employeePictures = useEmployeePictures()
  const pictures = employeePictures.models

  if (!pictures.length) {
    return (
      <Box
        border={{
          all: {
            style: 'solid',
            width: 's1',
            color: 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        paddingX="s24"
        paddingY="s32"
        alignItems="center"
        justifyContent="center"
      >
        <Text color="grey800" weight="normal" size="200">
          {i18n.t('employee_form.face_recognition_info.no_pictures_uploaded')}
        </Text>
      </Box>
    )
  }

  return (
    <BoxList>
      {pictures.map((picture) => (
        <Item
          employeePicture={picture}
          key={picture.id}
          canRemovePicture={canRemovePicture}
          canDownloadPicture={canDownloadPicture}
        />
      ))}
    </BoxList>
  )
}

export default observer(EmployeePictures)
